import React, { useEffect, useState } from 'react'
import AdministrationForm from '../../PageComponents/UI/AdministrationForm/AdministrationForm'
import apiService from '../../Services/apiServices'
import mdlCashBox from '../../Models/CashBox.js'

const CashBox = () => {
    const [accounts, setAccounts] = useState()
    const [branches, setBranches] = useState()
    const [warehouses, setWarehouses] = useState()

    const getAccounts = () => {
        apiService().get('accounts')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.map(record => ({ value: record.id, label: record.name }));
                    setAccounts(records)
                }
            })
    } 

    const getBranches = () => {
        apiService().get('branches')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.map(record => ({ value: record.id, label: record.name }));
                    setBranches(records)
                }
            })
    }

    const backData = (e) => {
        getWerhauses(e.value)
    }

    const getWerhauses = (branchId) => {
        apiService().query('warehousesByBranch', `branchId=${branchId}`)
            .then((response)=> {
                if(response.success) {
                    let records = response.data.map(record => ({ value: record.id, label: record.name }));
                    setWarehouses(records)
                }
            })
    }

    const headers = [
        { key: 'name', columnName: 'Emri', type: 'input', required: true },
        { key: 'branchId', name: "branchName", columnName: 'Filiali', type: 'select', options: branches, backData: true, subItem: "warehouseId", required: false },
        { key: 'warehouseId', name: "warehouseName", columnName: 'Depo', type: 'select', options: warehouses, required: false },
        { key: 'accountId', name: 'accountName', columnName: 'Konto', type: 'select', options: accounts, required: false }
    ]

    useEffect(() => {
        getAccounts();
        getBranches();
    }, [])

    return (
        <div>
            <AdministrationForm headers={headers} table="cashBoxes" model={new mdlCashBox()} backData={backData} />
        </div>
    )
}

export default CashBox
